"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperatorNodeDependencies = void 0;

var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var OperatorNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  createOperatorNode: _factoriesAny.createOperatorNode
};
exports.OperatorNodeDependencies = OperatorNodeDependencies;